import { IconButton } from '@civilgrid/ui/components';
import { useSnapshot } from 'valtio';
import { useOutOfRegion } from '~/hooks/useCheckRegionBounds';
import layerStore from '~/store2/layers';
import { LAYERS_PANEL_ID } from './panelIds';

export const Layers = () => {
  const isOutOfRegion = useOutOfRegion();
  const { isTOCVisible } = useSnapshot(layerStore);

  return (
    <IconButton
      id="layer-picker"
      data-testid="layers-button"
      icon="layers"
      variant="secondary"
      aria-haspopup="dialog"
      aria-expanded={isTOCVisible}
      aria-controls={isTOCVisible ? LAYERS_PANEL_ID : undefined}
      onClick={() => layerStore.toggleTOC()}
      disabled={isOutOfRegion}
    >
      Layers
    </IconButton>
  );
};
